export default "__VITE_ASSET__QCRf0yKQ__"